import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Avatar, IconButton, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import { Book } from '../types';


const useStyles = makeStyles(({
  listItemText: {
    maxWidth: '75%',
    overflow: 'hidden',
  },
}));

type bookListItemProps = {
  book: Book;
  openBookForm: (book: Book) => void;
  openAlert: (book: Book) => void;
};

const BookListItem = ({ book, openBookForm, openAlert }: bookListItemProps) => {
  const classes = useStyles();

  return (
    <ListItem divider>
      <ListItemAvatar>
        {
            book.coverImage ? 
            <Avatar alt={ book.title } src={ book.coverImage } variant='square' /> :
            <Avatar variant='square'>{ book.title.substr(0, 1) }</Avatar>
        }
      </ListItemAvatar>
      <ListItemText 
        className={ classes.listItemText }
        primary={ book.title }
        secondary={ book.authors.toString() }
      />
      <ListItemSecondaryAction>
        <IconButton 
          edge='end' 
          size='small' 
          aria-label='edit'
          onClick={() => openBookForm(book)}
        >
          <EditIcon />
        </IconButton>
        <IconButton 
          edge='end' 
          size='small' 
          aria-label='delete'
          onClick={() => openAlert(book)}
        >
          <DeleteIcon />
        </IconButton>
      </ListItemSecondaryAction>
    </ListItem>
  );
}

export default BookListItem;